var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#337FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8931 21.3018L25.463 17.6807H21.9523V15.327C21.9523 14.3369 22.4424 13.3693 24.0097 13.3693H25.6283V10.2858C24.6857 10.1355 23.7333 10.0541 22.7787 10.0425C19.8892 10.0425 18.0028 11.7795 18.0028 14.9196V17.6807H14.7998V21.3018H18.0028V30.0603H21.9523V21.3018H24.8931Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.24d93533399e5feb8fe1ca6230db706f.svg";
export { ForwardRef as ReactComponent };